import { useMemo } from "react";
import { Text, Stack, HStack, Image, Flex } from "@chakra-ui/react";

// import { Link } from "react-router-dom";

import Arrow from "assets/svg/icons-new/arrow.svg";
import { format, parseISO } from "date-fns";

export default function InviteItem({
  to,
  icon,
  disabled,
  current,
  onClick,
  children,
  name,
  email,
  createdAt,
  _for,
}) {
  const timeLabel = useMemo(() => {
    const map = {
      earnings: "Earned on",
      invites: "Signed up on",
      default: "Signed up on",
    };

    return map[_for ?? "default"];
  }, [_for]);

  return (
    <Flex
      to={to ?? "/dashboard/account/partners/view"}
      // as={Link}
      p="14px 18px"
      bg="white"
      onClick={onClick}
      borderRadius="16px"
      outline="1px solid transparent"
      disabled={disabled}
      _disabled={{
        opacity: 0.4,
        border: "none !important",
        boxShadow: "none !important",
      }}
      boxShadow={
        current
          ? "0 0 0 3px #06C3448f, 0 0 10px rgba(0,0,0,.05)"
          : "0 0 5px rgba(0,0,0,.05)"
      }
      border="2px solid transparent"
      borderColor={current ? "#06C344" : "transparent"}
      transition="all 300ms ease-in-out"
      _hover={{
        borderColor: "var(--primary)",
        cursor: disabled ? "not-allowed !important" : "pointer",
        // boxShadow: "0 0 0 3px #06C3448f, 0 0 10px rgba(0,0,0,.05)",
        transition: "all 300ms ease-in",
      }}
      _focus={{
        borderColor: "var(--primary)",
        transition: "all 300ms ease-in",
        boxShadow: "0 0 0 3px #06C3448f, 0 0 10px rgba(0,0,0,.05)",
      }}
    >
      <HStack justifyContent="space-between" w="100%">
        <Stack>
          <Text fontSize="14px" fontWeight="600" mt="0px !important">
            {name ?? "JohnX"}
          </Text>
          <Text
            color="#4E4B66"
            fontSize="12px"
            fontWeight="500"
            mt="0px !important"
          >
            {email ?? "johndoe@gmail.com"}
          </Text>
          {createdAt && (
            <Text color="#4E4B66" fontSize="10px" mt="0px !important">
              {timeLabel} {format(parseISO(createdAt), "dd-MM-yyyy")}
            </Text>
          )}
        </Stack>

        <Image src={Arrow} />
      </HStack>
    </Flex>
  );
}
